/* TAPE! quick-buy bar (Phase 2E §2.2). Shown below 990px while the main buy button is off screen and the
   footer isn't, so it never covers the button it stands in for or the footer links. */
if (!customElements.get('tape-quick-buy')) {
  customElements.define('tape-quick-buy', class TapeQuickBuy extends HTMLElement {
    connectedCallback() {
      this.target = document.getElementById(this.dataset.target);
      if (!this.target || !('IntersectionObserver' in window)) return;

      this.button = this.querySelector('.tape-qb__btn');
      this.media = window.matchMedia('(max-width: 989px)');
      this.mainVisible = true;
      this.footers = new Set();

      this.button.addEventListener('click', () => {
        if (this.target.disabled || this.target.getAttribute('aria-disabled') === 'true') return;
        this.target.click();
      });

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.target) {
            this.mainVisible = entry.isIntersecting;
          } else if (entry.isIntersecting) {
            this.footers.add(entry.target);
          } else {
            this.footers.delete(entry.target);
          }
        });
        this.update();
      });
      this.observer.observe(this.target);
      document.querySelectorAll('.shopify-section-group-footer-group').forEach((el) => this.observer.observe(el));

      this.onMedia = () => this.update();
      this.media.addEventListener('change', this.onMedia);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.media) this.media.removeEventListener('change', this.onMedia);
      document.body.classList.remove('tape-qb-open');
    }

    update() {
      const show = this.media.matches && !this.mainVisible && this.footers.size === 0;
      this.button.disabled = this.target.disabled || this.target.getAttribute('aria-disabled') === 'true';
      this.hidden = !show;
      document.body.classList.toggle('tape-qb-open', show);
    }
  });
}
